export type CommentDisplayMode = 'FULL' | 'HIDDEN';

const FULL = 'FULL';
const HIDDEN = 'HIDDEN';

export const commentDisplayMode: {
  FULL: CommentDisplayMode;
  HIDDEN: CommentDisplayMode;
} = {
  FULL,
  HIDDEN,
};
